import React, { useState, useCallback } from 'react';
import TabSelection from './components/TabSelection';
import CompanySidebar from './components/CompanySidebar';
import Companies from './Companies';

const tabs = [
  {
    label: 'Companies',
    show: { search: true },
  },
];

const CompanyIndex = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentTab, setCurrentTab] = useState(tabs[0]);
  const [openSideActionBoard, setOpenSideActionBoard] = useState(null);
  const [refetchCompanies, setRefetchCompanies] = useState(null);

  const handleCompanySuccess = useCallback(() => {
    if (refetchCompanies && typeof refetchCompanies === 'function') {
      refetchCompanies();
    }
  }, [refetchCompanies]);

  return (
    <div>
      {openSideActionBoard && (
        <CompanySidebar
          openSideActionBoard={openSideActionBoard}
          setOpenSideActionBoard={setOpenSideActionBoard}
          onSuccess={handleCompanySuccess}
        />
      )}
      <TabSelection
        tabs={tabs}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        setOpenSideActionBoard={setOpenSideActionBoard}
      />
      <div style={{ gap: '8px', overflow: 'auto' }} className="flex flex-col">
        {currentTab?.label === 'Companies' && (
          <Companies
            searchQuery={searchQuery}
            setOpenSideActionBoard={setOpenSideActionBoard}
            setRefetchCompanies={setRefetchCompanies}
          />
        )}
      </div>
    </div>
  );
};

export default CompanyIndex;
